import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { MonthAtGlanceInsightsEntity } from "../entities/MonthAtGlanceInsightsEntity";

export class GetMonthAtGlanceInsightsUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<MonthAtGlanceInsightsEntity> {
    return this.repository.getMonthAtGlanceInsights();
  }
}
